module.exports = __webpack_public_path__ + "static/media/img_WB.c20d9513.svg";